import {
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    where,
    updateDoc,
    serverTimestamp,
    deleteDoc
} from 'firebase/firestore';
import { db } from './config';

// Re-export everything from the posts module
export * from './posts/index';

export interface Post {
    id: string;
    userId: string;
    title: string;
    content: string;
    type: 'text' | 'video' | 'image';
    videoUrl?: string;
    videoUpload?: string;
    images?: string[];
    likes?: string[];
    publishingOptions?: {
        access: 'public' | 'paid_members' | 'members';
        price: string;
        earlyAccess: boolean;
        releaseDate: Date | null;
    };
    createdAt: any;
    updatedAt: any;
    stats?: {
        likes: number;
        comments: number;
        impressions: number;
    };
    isLocked?: boolean;
    isPinned?: boolean;
    likedBy?: string[];
    isPublished?: boolean;
}

export const deletePost = async (postId: string): Promise<void> => {
    try {
        await deleteDoc(doc(db, 'posts', postId));
    } catch (error) {
        console.error('Error deleting post:', error);
        throw error;
    }
};